import MuiTablePagination, { TablePaginationProps as MuiTablePaginationProps } from '@mui/material/TablePagination';

export type TablePaginationProps = MuiTablePaginationProps;

export const TablePagination = (props: TablePaginationProps) => {
  return <MuiTablePagination {...props} />;
};
